import { EditableContent } from '../../../edit/EditableContent';
import { pickBlockField } from '../../../lib/localized';
import type { BlockRenderProps } from '../../../types';

function parseStripItems(raw: string): { name: string; price: string }[] {
  return raw
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => {
      const parts = line.split(/\s+[—–-]\s+/);
      if (parts.length >= 2) {
        return { name: parts[0]!.trim(), price: parts.slice(1).join(' — ').trim() };
      }
      return { name: line, price: '' };
    });
}

export function SimpleMenuStrip({
  block,
  locale,
  isActive,
  activeEditTarget,
  editable,
}: BlockRenderProps) {
  const sectionTitle = pickBlockField(block.content, 'sectionTitle', locale);
  const itemsRaw = pickBlockField(block.content, 'items', locale);
  const items = parseStripItems(itemsRaw);
  const target = isActive ? activeEditTarget : null;

  return (
    <section
      className={['ws-menu-strip', isActive ? 'ws-block--active' : ''].filter(Boolean).join(' ')}
      data-block-id={block.blockId}
      data-component={block.componentType}
      id="menu"
    >
      <div className="ws-menu-strip__inner">
        <EditableContent
          as="h2"
          fieldKey="sectionTitle"
          editable={editable}
          activeEditTarget={target}
          className="ws-menu-strip__title"
        >
          {sectionTitle}
        </EditableContent>
        {editable ? (
          <EditableContent
            fieldKey="items"
            editable={editable}
            activeEditTarget={target}
            className="ws-menu-strip__editor"
          >
            {itemsRaw}
          </EditableContent>
        ) : (
          <ul className="ws-menu-strip__list">
            {items.map((item, index) => (
              <li key={`${item.name}-${index}`} className="ws-menu-strip__item">
                <span className="ws-menu-strip__name">{item.name}</span>
                {item.price ? <span className="ws-menu-strip__price">{item.price}</span> : null}
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
}
